import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const ConfirmDialog = ({
  open,
  onOpenChange,
  title = "Are you sure?",
  message = "",
  description = "This action cannot be undone.",
  confirmText = "Confirm",
  cancelText = "Cancel",
  destructive = false,
  confirmDisabled = false,
  onConfirm,
}) => {
  const handleConfirm = () => {
    onConfirm?.();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md space-y-2">
        {/* Header */}
        <DialogHeader className="space-y-1">
          <DialogTitle className="text-xl font-semibold">{title}</DialogTitle>
          {description && (
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {description}
            </p>
          )}
        </DialogHeader>

        {/* Message Box */}
        {message && (
          <div className="rounded-md text-sm ">
            {message}
          </div>
        )}

        {/* Action Buttons */}
        <DialogFooter className="flex justify-end gap-2 pt-3">
          <Button
            variant="outline"
            className="min-w-[90px]"
            onClick={() => onOpenChange(false)}
          >
            {cancelText}
          </Button>

          <Button
            variant={destructive ? "destructive" : "default"}
            className="min-w-[90px]"
            disabled={confirmDisabled}
            onClick={handleConfirm}
          >
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDialog;
